import z from 'zod';
import { DateTimeSchema, objectIdRef, ObjectIdSchema } from '../common.js';
import { ToolName } from '../toolSchemas.js';

// One "always allow" grant for a write tool; grantedAt shown on the options page and kept for audit
export const UserToolPermissionGrant = z.object({
  toolName: ToolName,
  grantedAt: DateTimeSchema,
});
export type UserToolPermissionGrant = z.infer<typeof UserToolPermissionGrant>;

// Per-user (AuthUser) per-account write-tool grants, scoped the same way as IUserMemory
export const IUserToolPermission = z.object({
  _id: ObjectIdSchema,
  account: objectIdRef('Account'),
  user: objectIdRef('AuthUser'),
  grants: UserToolPermissionGrant.array().default([]),
  createdAt: DateTimeSchema,
  updatedAt: DateTimeSchema,
});
export type IUserToolPermission = z.infer<typeof IUserToolPermission>;
